import { Directive, Input, ViewContainerRef, TemplateRef, SimpleChanges, Renderer2, OnChanges } from '@angular/core';
import { AdministratorService } from '@app/core/services/administrator/administrator.service';
import { UserAdminUI } from '@app/core/services/administrator/models/user-admin.model';
import { environment } from '@env/environment';
import { BehaviorSubject } from 'rxjs';

/**
 * Hide or disable an element depending on a configuration (array of account type) with in params the mobilityAccount type.
 * The ROOTADMIN agents are not affected by this configuration
 *
 * @example
 * <pre><code>
 *  <div *apSecureAccountType="type"></div>
 * </code></pre>
 */
@Directive({
    selector: '[apSecureAccountType]',
    standalone: false
})
export class ApSecureAccountTypeDirective implements OnChanges {

  @Input('apSecureAccountTypeMode')
  mode: 'DISABLED' | 'HIDDEN' = 'HIDDEN';

  @Input('apSecureAccountType')
  types: string | string[] = [];

  loggedAgent$: BehaviorSubject<UserAdminUI>;
  hasRights = true;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private renderer: Renderer2,
    private administratorService: AdministratorService) { }

  ngOnChanges(_changes: SimpleChanges): void {
    this.manageApSecure();
  }

  /**
   * Manage roles and permissions and apply mode to the DOM element
   */
  private manageApSecure() {
    this.loggedAgent$ = this.administratorService.loggedAgent$;

    if (!this.loggedAgent$) {
      this.hasRights = false;
    }

    const accountTypesNotEditable = environment.user.accountTypesNotEditable;

    let types = undefined;
    if (this.types) {
      types = typeof this.types === 'string' ? this.types.split(',') : this.types;
    }

    if (types && types.some(t => t && accountTypesNotEditable.includes(t))) {
      this.hasRights = false;
    }

    if (this.loggedAgent$.getValue().roleInfos.name === 'ROOT_ADMIN' || this.hasRights) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.applyMode();
    }

  }

  private applyMode() {
    if (this.mode === 'DISABLED') {
      const view = this.viewContainer.createEmbeddedView(this.templateRef);
      const rootElem = view.rootNodes[0];
      if (rootElem) {
        this.renderer.setProperty(rootElem, 'disabled', true);
      }
    } else {
      this.viewContainer.clear();
    }
  }

}
